export default __webpack_public_path__ + "feaff916fd609e310efe2628a9260cfa.woff2";